<div class="page-wrap">
  <div
    class="w-full flex flex-col align-middle *:justify-center bg-container-bg-default sticky top-0 z-10 border border-action-bg-muted">
    <div class="firmware-creation-heading">{{ modelTitle }}</div>

    <remote-update-domain-app-environment-build-info></remote-update-domain-app-environment-build-info>
  </div>

  <div class="content-row">
    <remote-update-domain-left-menu
      [items]="menuItems"
      [store]="store!"
      [currentSection]="currentSection"
      (selectSection)="goToSection($event)">
    </remote-update-domain-left-menu>

    <div class="main-content">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="footer">
    <button matButton (click)="formCancel.emit()">
      <div class="flex gap-025-rem items-center justify-center">
        <div>
          <img src="/svgs/left-arrow.svg" alt="file" />
        </div>
        <div>Cancel</div>
      </div>
    </button>
    <button extended matButton="filled" (click)="nextStep.emit()">
      @if(!actionButtonLabel){
      <div class="flex gap-025-rem items-center justify-center">
        <p>Next</p>
        <img src="/svgs/right-arrow.svg" alt="file" />
      </div>
      }@else {
      <p>
        {{ isEditingFirmwarePackage() || isEditingRolloutPlan() ? 'Save changes' : finalButtonText
        }}
      </p>
      }
    </button>
  </div>
</div>
